import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReturnInvoicesComponent } from './return-invoices.component';
import { ReturnInvoicesListComponent } from './return-invoices-list/return-invoices-list.component';
import { ReturnInvoicesDetailsComponent } from './return-invoices-details/return-invoices-details.component';
import { CreateReturnOrderComponent } from './create-return-order/create-return-order.component';
import { CreateReturnInvoiceStepperComponent } from './create-return-invoice-stepper/create-return-invoice-stepper.component';
import { CreateCreditReturnInvoiceStepperComponent } from './create-credit-return-invoice-stepper/create-credit-return-invoice-stepper.component';
import { CreateReturnOrderManualComponent } from './create-return-order-manual/create-return-order-manual.component';

const routes: Routes = [
  {
    path: '',
    component: ReturnInvoicesComponent,
    children: [
      {
        path: '',
        component: ReturnInvoicesListComponent,
        data: {
          title: 'Listado de Ordenes de Devolución',
          id: 'ReturnInvoicesModule_returnInvoices'
        }
      },
      {
        path: 'new',
        component: CreateReturnOrderComponent,
        data: {
          title: 'Creación de Orden de Devolución',
          id: 'CreateReturnOrderComponent_returnInvoices_new'
        }
      },
      {
        path: 'newManual',
        component: CreateReturnOrderManualComponent,
        data: {
          title: 'Creación de Orden de Devolución de Factura MT',
          id: 'CreateReturnOrderComponent_returnInvoices_new'
        }
      },
      {
        path: 'createCreditNote/:code/:operation',
        component: CreateReturnInvoiceStepperComponent,
        data: {
          title: 'Devolución de Factura',
          id: 'CreateReturnInvoiceStepperComponent_returnInvoices'
        }
      },
      {
        path: 'createContractCreditNote/:code/:operation',
        component: CreateCreditReturnInvoiceStepperComponent,
        data: {
          title: 'Devolución de Factura al Crédito',
          id: 'CreateReturnInvoiceStepperComponent_returnInvoices'
        }
      },
      {
        path: ':code',
        component: ReturnInvoicesDetailsComponent,
        data: {
          title: 'Detalle de Devolución',
          id: 'ReturnInvoicesDetailsComponent_returnInvoices'
        }
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReturnInvoicesRoutingModule { }
